import React from 'react';
import { Box, Container, Typography, Link, Grid, Divider, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                py: 5,
                px: 3,
                mt: 4,
                background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(12,150,180,1) 100%)',
                color: 'white'

            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* About Us Section */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom>
                            About Us
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ color: 'white' }}>
                            Learn more about our company and mission to provide top services.
                        </Typography>
                    </Grid>

                    {/* Services Section */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom>
                            Services
                        </Typography>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            Web Development
                        </Link>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            Mobile Development
                        </Link>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            AI & Machine Learning
                        </Link>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            Cloud Services
                        </Link>
                    </Grid>

                    {/* Resources Section */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom>
                            Resources
                        </Typography>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            Blog
                        </Link>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            Case Studies
                        </Link>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            Documentation
                        </Link>
                        <Link href="#" underline="hover" color="inherit" display="block">
                            FAQs
                        </Link>
                    </Grid>

                    {/* Social Media Section */}
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom>
                            Follow Us
                        </Typography>
                        <Box>
                            <IconButton aria-label="Facebook" href="#" color="inherit">
                                <FacebookIcon fontSize="large" />
                            </IconButton>
                            <IconButton aria-label="Twitter" href="#" color="inherit">
                                <TwitterIcon fontSize="large" />
                            </IconButton>
                            <IconButton aria-label="LinkedIn" href="#" color="inherit">
                                <LinkedInIcon fontSize="large" />
                            </IconButton>
                            <IconButton aria-label="Instagram" href="#" color="inherit">
                                <InstagramIcon fontSize="large" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>

                {/* Divider */}
                <Divider sx={{ my: 3, backgroundColor: 'white' }} />

                {/* Bottom Section */}
                <Box textAlign="center">
                    <Typography variant="body2" color="textSecondary" sx={{ color: 'white' }}>
                        © 2024 Your Company Name. All rights reserved.
                    </Typography>
                    <Box mt={1}>
                        <Link href="#" underline="hover" color="inherit" sx={{ mx: 1 }}>
                            Privacy Policy
                        </Link>
                        <Link href="#" underline="hover" color="inherit" sx={{ mx: 1 }}>
                            Terms of Service
                        </Link>
                        <Link href="#" underline="hover" color="inherit" sx={{ mx: 1 }}>
                            Contact Us
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
